import React from 'react';
import { motion } from 'framer-motion';
import Hero from '../components/Hero';
import Purpose from '../components/Purpose';
import Courses from '../components/Courses';
import Features from '../components/Features';
import PastRecords from '../components/PastRecords';
import Registration from '../components/Registration';

const Home = () => {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      className="pt-16"
    >
      <Hero />
      <Purpose />
      <Courses />
      <Features />
      <PastRecords />
      <Registration />
    </motion.main>
  );
};

export default Home;